import React from "react";
import { useNavigate } from "react-router-dom";
import { useVisitor } from "../context/VisitorAuthContext";
import { Lock, X, Sparkles } from "lucide-react";

export const PaywallModal = () => {
  const { paywall, closePaywall, visitor, openAuth } = useVisitor();
  const nav = useNavigate();
  if (!paywall) return null;

  const go = () => {
    closePaywall();
    if (!visitor) { openAuth(); return; }
    nav("/club");
  };

  return (
    <div className="fixed inset-0 z-[60] bg-black/60 flex items-center justify-center p-4" onClick={closePaywall} data-testid="paywall-modal">
      <div className="font-ui bg-white rounded-2xl max-w-md w-full p-7 border-2 border-[#C5A059] shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between">
          <span className="w-12 h-12 rounded-xl bg-[#C5A059] flex items-center justify-center"><Lock className="w-6 h-6 text-black" /></span>
          <button onClick={closePaywall} data-testid="paywall-close" className="text-slate-400 hover:text-black"><X className="w-5 h-5" /></button>
        </div>
        <h2 className="font-pub text-2xl font-extrabold text-black mt-4">{paywall.title}</h2>
        <p className="font-ui text-slate-600 mt-2 leading-relaxed">{paywall.message}</p>
        <ul className="mt-4 space-y-1.5">
          {["Unlimited curios & quizzes", "Every category + Daily archive", "Host / group quiz mode"].map((t) => (
            <li key={t} className="flex items-center gap-2 font-ui text-sm text-slate-700">
              <Sparkles className="w-4 h-4 text-[#A5812F]" /> {t}
            </li>
          ))}
        </ul>
        <button onClick={go} data-testid="paywall-cta" className="mt-6 w-full bg-[#C5A059] hover:bg-[#B08D44] active:scale-[0.98] text-black font-pub font-extrabold py-3.5 rounded-xl border-2 border-black shadow-[0_3px_10px_rgba(26,22,21,0.14)] transition-all uppercase tracking-wide">
          {visitor ? "Join the Club →" : "Sign in to join →"}
        </button>
        <button onClick={closePaywall} className="mt-2 w-full font-ui text-sm text-slate-400 hover:text-black py-1">Maybe later</button>
      </div>
    </div>
  );
};
